<script setup lang="ts">
const {
  public: { cdnUrl },
} = useRuntimeConfig();
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h2>{{ $t('homepage.element.title') }}</h2>
        <h3>{{ $t('homepage.element.subtitle') }}</h3>

        <p>{{ $t('homepage.element.text') }}</p>

        <Button as="a" :to="`${cdnUrl}/documents/ELEMENT 2024.pdf`">
          {{ $t('homepage.element.actions.show-report') }}
        </Button>
      </div>

      <div class="col justify-center image-column">
        <picture>
          <img
            alt=""
            aria-hidden="true"
            loading="lazy"
            class="image"
            :src="`${cdnUrl}/images/redesign/homepage/element.png`"
            :srcset="`${cdnUrl}/images/redesign/homepage/element@2x.png 2x, ${cdnUrl}/images/redesign/homepage/element@3x.png 3x`"
          />
        </picture>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h2 {
  margin-bottom: 1rem;
}

.justify-center {
  align-items: flex-end;
}

.image {
  width: 100%;
  min-height: auto;
}
</style>
